/**
 * IconPicker - выбор иконки из списка
 */
import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import { POPULAR_ICONS, ALL_ICONS } from './iconsList';

export default function IconPicker({
  label,
  value,
  onChange,
  icons, // Если не передан - используем POPULAR_ICONS, но с возможностью раскрыть ALL_ICONS
  showAll = false, // Показывать все иконки сразу
}) {
  // Если icons не передан, используем популярные с возможностью раскрытия
  const useDefaultIcons = !icons;
  const iconsList = icons || (showAll ? ALL_ICONS : POPULAR_ICONS);
  const [expanded, setExpanded] = useState(false);

  // Определяем что показывать
  const displayIcons = useDefaultIcons
    ? (expanded ? ALL_ICONS : POPULAR_ICONS)
    : (expanded ? iconsList : iconsList.slice(0, 18));

  const canExpand = useDefaultIcons || iconsList.length > 18;

  return (
    <div>
      {label && (
        <label className="block text-sm font-medium mb-2">{label}</label>
      )}
      <div className="flex flex-wrap gap-1">
        {displayIcons.map((iconName) => (
          <button
            key={iconName}
            onClick={() => onChange(iconName)}
            className={`p-2 rounded transition-colors ${
              value === iconName
                ? 'bg-primary text-primary-foreground'
                : 'bg-muted hover:bg-primary/10'
            }`}
            title={iconName}
            type="button"
          >
            <Icon name={iconName} size={16} />
          </button>
        ))}
        {canExpand && (
          <button
            onClick={() => setExpanded(!expanded)}
            className="p-2 rounded bg-muted hover:bg-primary/10 text-text-secondary"
            type="button"
            title={expanded ? 'Свернуть' : 'Показать все'}
          >
            <Icon name={expanded ? 'ChevronUp' : 'MoreHorizontal'} size={16} />
          </button>
        )}
      </div>
    </div>
  );
}
